var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrame(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "17.000000pt",
    height: "17.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M748 5110 c-285 -48 -523 -234 -629 -492 -56 -136 -59 -173 -59 -683 l0 -465 155 0 155 0 0 443 c0 499 3 526 70 637 64 108 154 185 272 233 51 21 68 22 501 25 l447 3 0 154 0 155 -432 -1 c-238 -1 -454 -5 -480 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3470 4966 l0 -156 388 0 c213 0 419 -5 457 -10 99 -14 214 -73 288 -147 71 -71 132 -188 147 -283 5 -36 10 -253 10 -487 l0 -423 156 0 155 0 -4 493 c-4 549 -2 534 -78 697 -100 214 -276 366 -504 437 l-90 27 -462 4 -463 3 0 -155z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 1173 l4 -488 27 -88 c79 -255 240 -431 486 -531 129 -52 174 -56 646 -56 l435 0 0 155 0 155 -409 0 c-229 0 -432 4 -462 10 -170 31 -325 169 -392 348 -20 55 -21 77 -25 520 l-3 462 -155 0 -155 0 3 -487z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4750 1212 c0 -364 -3 -458 -15 -505 -45 -174 -180 -315 -356 -373 -47 -16 -106 -18 -481 -22 l-428 -4 0 -154 0 -155 458 3 c435 4 460 5 529 26 260 79 449 243 544 474 56 136 59 173 59 688 l0 470 -155 0 -155 0 0 -448z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/frame.5158ac40.svg";
export { ForwardRef as ReactComponent };